import React from "react";

function CourseButton({ title, description, icon , url}) {
  return (
    <div className="flex[1] mt-3 mb-3">
      <div className="bg-[#393E46] p-6 ml-4 mr-4 rounded-lg shadow-md 
                      hover:shadow-lg transition-all duration-300 hover:bg-[#50575e]">
        <h1 className="text-xl font-semibold text-white flex items-center gap-2">
          <span className="text-2xl">{icon}</span> {title}
        </h1>
        <p className="text-gray-300 mt-2">{description || "No description available"}</p>
        <a href={url}>
        <button className="mt-4 px-4 py-2 rounded bg-gradient-to-r from-violet-500 to-red-500 
                           text-white font-medium hover:scale-105 transition-all duration-300">
          Learn More
        </button>
        </a>
      </div>
    </div>
  );
}

export default CourseButton;
